import http from '@services/http'
import { USER_PENALTY_TYPE } from '@v2/constants/common'

class UserPenalty {

  /**
   * 유저 제재 상태 메시지를 받는다.
   * 값을 null 일 경우 제재가 아니다.
   */
  async checkUserPenalty(
    data: { penaltyType: USER_PENALTY_TYPE }
  ): Promise<{ penaltyEnabled: boolean, penaltyMessage: string }> {
    return http.post('penalty/checkUserPenalty', data || {})
  }
}

export default new UserPenalty()
